import React, { createContext, useState } from 'react';

const UserContext = createContext();

const UserProvider = (props) => {
  const [userPermissions, setUserPermissions] = useState({ permisison: true });

  return (
    <UserContext.Provider value={{
      setUserPermissions,
      userPermissions,
    }}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;

export { UserProvider };